import {NO_MATCH, fuzzyScore} from './fuzzy-score'

type fuzzyFilterProps<T> = {
  items: T[]
  filter: string
  key: (option: T) => string
  // Used when you want to compare against two attributes, and take the highest score.
  // An example could be comparing against a users login, and then name, and taking the highest score.
  secondaryKey?: (option: T) => string
}

export const fuzzyFilter = <T>({items, filter, key, secondaryKey}: fuzzyFilterProps<T>): T[] => {
  // Single pass: score, filter out non-matches, and collect results
  const scoredItems: Array<readonly [number, T]> = []

  for (const item of items) {
    const primaryScore = fuzzyScore(filter, key(item))
    const finalScore = secondaryKey ? Math.max(primaryScore, fuzzyScore(filter, secondaryKey(item))) : primaryScore

    if (finalScore > NO_MATCH) {
      scoredItems.push([finalScore, item] as const)
    }
  }

  // Sort by score descending, then alphabetically for ties
  scoredItems.sort(([aScore, a], [bScore, b]) => {
    if (bScore === aScore) {
      return key(a).localeCompare(key(b))
    }
    return bScore - aScore
  })

  // Extract items from scored tuples
  return scoredItems.map(([, item]) => item)
}
